module.exports = __webpack_public_path__ + "img/PLUM_120X35.87a18a98.png";